/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import { SELECTED_STARTUP_DOWNLOAD_EXCEL, STARTUP_CHECK_BOX_DATA, STARTUP_DOWNLOAD_EXCEL } from "../../../../constants/api"
import { post } from "../../../../effects/api/api.common";
import { downloadDocument } from "../../../../utils/CommonMethods";
import React, { FC } from "react";

let dataHolder: Array<string> = [];

const STARTUP_DETAILS = 'Startup Details';
const APPLICATION_DETAILS = "Application Details";
const TRANCHE_DETAILS_1 = "1st Tranche Details";
const TRANCHE_DETAILS_2 = "2nd Tranche Details";
const TRANCHE_DETAILS_3 = "3rd Tranche Details";
const TRANCHE_DETAILS_4 = "4th Tranche Details";
const PROGRESS_OF_STARTUP = 'Progress Of Startup';

const updateDataHolder = (isClicked: boolean, item: string) => {
  if (isClicked) {
    if (!dataHolder.find((i) => item === i)) {
      dataHolder.push(item);
    }
  } else {
    dataHolder = dataHolder.filter((i) => i !== item);
  }
};

interface interfaceProps {
  startup: Array<any>;
  title: any;
  item: any;
  StartUpSelected: boolean;
  setStartUpDetailFirstSelected:any;
}

const StartUpDetailItem: FC<interfaceProps> = ({
  startup,
  title,
  item,
  StartUpSelected,
  setStartUpDetailFirstSelected
}: interfaceProps) => {

  const [itemSelected, setItemSelecetd] = useState(false);

  useEffect(() => {
    /* if (itemSelected && !StartUpSelected) {
      return;
    } */
    setItemSelecetd(StartUpSelected);
    updateDataHolder(StartUpSelected, item);
    return () => { };
  }, [StartUpSelected]);

  const onClick = (event: React.ChangeEvent<HTMLInputElement>) => {
    updateDataHolder(event.target.checked, item);
    setStartUpDetailFirstSelected(false)
    setItemSelecetd(event.target.checked);
  }

  // Table Data
  return (
    <div className="row hover  mb-2">
      <div className="col-10"> {startup[title][item]}</div>
      <div className="col-2">
        <div className="form-check">
          <input
            className="form-check-input"
            type="checkbox"
            checked={itemSelected}
            onChange={onClick}
            id="flexCheckDefault"
          />
        </div>
      </div>
    </div>
  );
}

interface interfaceBase {
  startup: Array<any>;
  title: any;
  items: any;
}

const StartUpDetail: FC<interfaceBase> = ({
  startup,
  title,
  items,
}: interfaceBase) => {

  const [startUpDetailSelected, setStartUpDetailSelected] = useState(false);
  const [startUpDetailFirstSelected, setStartUpDetailFirstSelected] = useState(false);

  const onClick = (event: React.ChangeEvent<HTMLInputElement>) => {
    setStartUpDetailSelected(event.target.checked);
    setStartUpDetailFirstSelected(event.target.checked)
  };

  
  // Table Main Header
  return (
    <div>
      <div className="row">
        <div className="col-10">
          <p className="h4">{title}</p>
        </div>
        <div className="col-2">
          <div className="form-check">
            <input
              className="form-check-input"
              type="checkbox"
              checked={startUpDetailFirstSelected}
              id="flexCheckDefault"
              onChange={onClick}
            />
          </div>
        </div>
      </div>
      {
        items &&
        items.map((i: any, key: number) => {
          return (
            <div key={key}>
              <StartUpDetailItem
                title={title}
                startup={startup}
                item={i}
                StartUpSelected={startUpDetailSelected}
                setStartUpDetailFirstSelected={setStartUpDetailFirstSelected}
              ></StartUpDetailItem>
            </div>
          );
        })
      }
    </div >
  );
}



interface Props {
  countRef: React.MutableRefObject<number>;
}
export const StartUpReportComponent = ({ countRef }: Props) => {     

  const [startUp, setStartUp] = useState<any>({});

  const downloadExcel = async () => {
    const {
      data: { data, result },
    } = await post(STARTUP_DOWNLOAD_EXCEL, dataHolder);
    if (result === "success") {
      downloadDocument(data, "startup_list");
    }
    else{
      //console.log(`Column not found: 1054 Unknown column 'fund_raised' in 'field list' (SQL: select (CASE WHEN stage_id = \"1\" THEN \"Proof of concept\" WHEN stage_id = \"2\" THEN \"Progress of prototype development\" WHEN stage_id = \"3\" THEN \"Progress of product development\" WHEN stage_id = \"4\" THEN \"Progress of field trials\" WHEN stage_id = \"5\" THEN \"Progress of market launch\" END) AS stage_of_startup_reported_first,progress_in_text as progress_of_proof_of_concept_first, fund_raised as quantum_funding_raised_first, jobs_created as jobs_created_by_startup_first, turnover as turnover_of_startup_first from 'startup_progress_overview' where 'startup_application_id' = 1 order by 'id' asc)`);  
    }
  };

  const downloadExcel1 = async () => {
    const {
      data: { data, result },
    } = await post(SELECTED_STARTUP_DOWNLOAD_EXCEL, dataHolder);
    if (result === "success") {
      downloadDocument(data, "startup_list");
    }
    else{
      //console.log(`Column not found: 1054 Unknown column 'fund_raised' in 'field list' (SQL: select (CASE WHEN stage_id = \"1\" THEN \"Proof of concept\" WHEN stage_id = \"2\" THEN \"Progress of prototype development\" WHEN stage_id = \"3\" THEN \"Progress of product development\" WHEN stage_id = \"4\" THEN \"Progress of field trials\" WHEN stage_id = \"5\" THEN \"Progress of market launch\" END) AS stage_of_startup_reported_first,progress_in_text as progress_of_proof_of_concept_first, fund_raised as quantum_funding_raised_first, jobs_created as jobs_created_by_startup_first, turnover as turnover_of_startup_first from 'startup_progress_overview' where 'startup_application_id' = 1 order by 'id' asc)`);  
    }
  };

  const fetchData = async () => {
    const {
      data: { data, result },
    } = await post(STARTUP_CHECK_BOX_DATA, {});
    setStartUp(data);
  };

  useEffect(() => {
    fetchData();
  }, []);
  
  const getData = (title: string) => {
    return startUp[title] ? Object.keys(startUp[title]) : [];
  };

  return (
    <>
      <div>
        <div className="data1 mx-5 my-5">
          <StartUpDetail
            title={STARTUP_DETAILS}
            startup={startUp}
            items={getData(STARTUP_DETAILS)}
          ></StartUpDetail>
        </div>
        <div className="data1 mx-5 my-5">
          <StartUpDetail
            title={APPLICATION_DETAILS}
            startup={startUp}
            items={getData(APPLICATION_DETAILS)}
          ></StartUpDetail>
        </div>
        <div className="data1 mx-5 my-5">
          <StartUpDetail
            title={TRANCHE_DETAILS_1}
            startup={startUp}
            items={getData(TRANCHE_DETAILS_1)}
          ></StartUpDetail>
        </div>
        <div className="data1 mx-5 my-5">
          <StartUpDetail
            title={TRANCHE_DETAILS_2}
            startup={startUp}
            items={getData(TRANCHE_DETAILS_2)}
          ></StartUpDetail>
        </div>
        <div className="data1 mx-5 my-5">
          <StartUpDetail
            title={TRANCHE_DETAILS_3}
            startup={startUp}
            items={getData(TRANCHE_DETAILS_3)}
          ></StartUpDetail>
        </div>
        <div className="data1 mx-5 my-5">
          <StartUpDetail
            title={TRANCHE_DETAILS_4}
            startup={startUp}
            items={getData(TRANCHE_DETAILS_4)}
          ></StartUpDetail>
        </div>
        <div className="data1 mx-5 my-5">
          <StartUpDetail
            title={PROGRESS_OF_STARTUP}
            startup={startUp}
            items={getData(PROGRESS_OF_STARTUP)}
          ></StartUpDetail>
        </div>

        {/* {console.log(countRef.current)} */}
        {(countRef.current ===2)? 
        <>
          <div className="data1 mx-5 buttonCss">
          <Button
            variant="primary"
            className="btn-yellow-primary tertiary text-uppercase"
            onClick={() => {
              //console.log(dataHolder);
              downloadExcel1();
            }}
          >
            Generate Record
          </Button>          
        </div>
        </> 
        
        : 
        <>

        <div className="data1 mx-5 buttonCss">  
          <Button
            variant="primary"
            className="btn-yellow-primary tertiary text-uppercase"
            onClick={() => {
              //console.log(dataHolder);
              downloadExcel();
            }}
          >
            Generate Record
          </Button>
          </div>
        </>
        
        }
        
      </div>
    </>
  )
}
